<template>
  <v-layout row>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-layout row wrap v-on="on">
          <div class="text-no-wrap" style="width: 100%">
            <div
              class="d-flex flex-row text-no-wrap justify-space-between align-end"
            >
              <div>
                <v-progress-circular
                  v-if="hasDelivery && loading"
                  :size="12"
                  :width="2"
                  color="green darken-1"
                  indeterminate
                ></v-progress-circular>

                <!-- taxa de entrega -->
                <span
                  v-else-if="hasDelivery"
                  class="caption green--text darken-1"
                >
                  <b>{{ item.delivered_rate | numeral("0.00%") }}</b>
                </span>

                <small
                  v-if="hasDelivery"
                  class="grey--text text--darken-1 pr-1 pl-1"
                  >(</small
                >
                <span v-if="hasDelivery" class="caption green--text darken-1">
                  {{ item.delivered | numeral("0,0") }}
                </span>
                <span v-else class="primary--text caption">
                  <b>{{ item.notifications | numeral("0,0") }}</b>
                </span>
                <small
                  v-if="hasDelivery"
                  class="grey--text text--darken-1 pr-1 pl-1"
                  >/</small
                >
                <span v-if="hasDelivery" class="primary--text caption">{{
                  item.notifications | numeral("0,0")
                }}</span>
                <small
                  v-if="hasDelivery"
                  class="grey--text text--darken-1 pr-1 pl-1"
                  >)</small
                >
              </div>

              <div class="queued-count-container pr-1">
                <!-- enfileirados -->
                <span
                  v-if="queued || queued === 0"
                  class="caption grey--text text--darken-1"
                >
                  {{ queued | numeral("0,0") }}
                </span>
              </div>
            </div>
          </div>
          <div class="progress-container">
            <div
              v-if="item.notifications"
              class="notifications-bar primary"
              :style="{
                width: progress(item.notifications, item.queued) + '%',
              }"
            >
              <div
                v-if="!loading && item.delivered_rate"
                class="delivered-bar green lighten-1"
                :style="{
                  width:
                    (item.delivered_rate > 1
                      ? 100
                      : item.delivered_rate * 100) + '%',
                }"
              ></div>
            </div>
          </div>
        </v-layout>
      </template>

      <!-- conteudo da tooltip -->
      <span>
        <ul>
          <li
            v-if="
              !loading && approachesWithDelivery.includes(item.approach_type)
            "
          >
            Taxa de entrega:
            {{ item.delivered_rate | numeral("0.00%") }}
          </li>
          <li
            v-if="
              !loading && approachesWithDelivery.includes(item.approach_type)
            "
          >
            {{ item.delivered | numeral("0,0") }} notificaç{{
              item.delivered == 1 ? "ão" : "ões"
            }}
            entregue{{ item.delivered == 1 ? "" : "s" }}
          </li>
          <li>
            {{ item.notifications | numeral("0,0") }}
            notificaç{{ item.notifications == 1 ? "ão" : "ões" }} enviada{{
              item.notifications == 1 ? "" : "s"
            }}
          </li>
          <li>
            {{ item.queued | numeral("0,0") }} notificaç{{
              item.queued == 1 ? "ão" : "ões"
            }}
            enfileiradas
          </li>
        </ul>
      </span>
    </v-tooltip>

    <v-btn
      v-if="showDetaisBtn"
      icon
      small
      class="ma-0 pa-0 ml-1"
      @click="setFiring(item)"
    >
      <v-icon :color="btnColor"> mdi-alert-outline </v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
export default {
  name: "NotificationCell",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    approachesWithDelivery: {
      type: Array,
      default: () => ["SMS", "WHATSAPP", "EMAIL"],
    },
  },
  computed: {
    hasDelivery() {
      return (
        this.item &&
        this.item.approach_type &&
        this.approachesWithDelivery.includes(this.item.approach_type)
      );
    },
    queued() {
      if (this.item.type === "INCENTIVE") return this.item.notifications || 0;
      return this.item.queued || 0;
    },
    showDetaisBtn() {
      return (
        (this.item.total_skips ||
          this.item.notifications != this.item.simulated) &&
        ["DONE", "SENDING", "QUEUED"].includes(this.item.status)
      );
    },
    itemHasError() {
      return (
        (this.item.status != "QUEUED" && this.queued === 0) ||
        (this.item.notifications / this.queued === 0 &&
          this.item.notifications > 0) ||
        this.item.missing > 0
      );
    },
    btnColor() {
      return this.itemHasError
        ? "red"
        : (this.item.notifications / this.queued) * 100 < 80
        ? "orange"
        : "primary";
    },
  },
  methods: {
    setFiring(notificationFiring) {
      this.$emit("set-firing", notificationFiring);
    },
    progress(value, total) {
      const result = (value / total) * 100;
      if (isNaN(result)) return 0;
      if (result > 100) return 100;
      return result;
    },
  },
};
</script>

<style scoped lang="scss">
.progress-container,
.notifications-bar,
.delivered-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 15px;
  box-shadow: inset 0 -4px 8px -2px rgba(0, 0, 0, 0.22);
  overflow: hidden;
}

.progress-container {
  position: relative;
  height: 10px;
  width: 100%;
  background-color: #e0e0e0;
  box-shadow: inset 0 4px 8px -2px rgba(0, 0, 0, 0.18);
}

.notifications-bar {
  z-index: 1;
}

.delivered-bar {
  z-index: 2;
}

.queued-count-container {
  flex: 0 0 auto !important;
  width: min-content;
}
</style>
